module.exports = __webpack_public_path__ + "img/a17a44c.svg";